module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-main', [_c('v-container', {
    attrs: {
      "container--fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md4": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "text-center avatar-header"
  }, [_c('div', {
    staticClass: "private-register-logo-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoPrimary,
      "alt": "Kobe"
    }
  })])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Register using your information below :")]), _vm._v(" "), _c('v-form', [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.nameErrors,
      "prepend-icon": "person",
      "name": "firstName",
      "label": "First Name",
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.$v.registerUser.firstName.$touch()
      },
      "blur": function($event) {
        return _vm.$v.registerUser.firstName.$touch()
      }
    },
    model: {
      value: (_vm.registerUser.firstName),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "firstName", $$v)
      },
      expression: "registerUser.firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "person",
      "name": "lastName",
      "label": "Last Name",
      "type": "text"
    },
    model: {
      value: (_vm.registerUser.lastName),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "lastName", $$v)
      },
      expression: "registerUser.lastName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "error-messages": _vm.registerEmailErrors,
      "prepend-icon": "email",
      "name": "email",
      "disabled": "",
      "label": "Email",
      "type": "email"
    },
    on: {
      "input": function($event) {
        return _vm.$v.registerUser.email.$touch()
      },
      "blur": function($event) {
        return _vm.$v.registerUser.email.$touch()
      }
    },
    model: {
      value: (_vm.registerUser.email),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "email", $$v)
      },
      expression: "registerUser.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "mdi-instagram",
      "name": "instagram",
      "disabled": _vm.disableIgHandle,
      "label": "Instagram Account Name",
      "type": "text"
    },
    model: {
      value: (_vm.registerUser.igHandle),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "igHandle", $$v)
      },
      expression: "registerUser.igHandle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "fab fa-tiktok",
      "name": "tiktok",
      "disabled": _vm.disableTikTokHandle,
      "label": "TikTok Account Name",
      "type": "text"
    },
    model: {
      value: (_vm.registerUser.tiktokHandle),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "tiktokHandle", $$v)
      },
      expression: "registerUser.tiktokHandle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "fab fa-youtube",
      "name": "youtube",
      "disabled": _vm.disableYoutubeHandle,
      "label": "Youtube Account Name",
      "type": "text"
    },
    model: {
      value: (_vm.registerUser.youtubeHandle),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "youtubeHandle", $$v)
      },
      expression: "registerUser.youtubeHandle"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "prepend-icon": "my_location",
      "items": _vm.locations,
      "label": "Select your location"
    },
    model: {
      value: (_vm.registerUser.location),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "location", $$v)
      },
      expression: "registerUser.location"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "error-messages": _vm.registerPasswordErrors,
      "id": "regPassword",
      "prepend-icon": "lock",
      "name": "regPassword",
      "label": "Password",
      "type": "password"
    },
    on: {
      "input": function($event) {
        return _vm.$v.registerUser.password.$touch()
      },
      "blur": function($event) {
        return _vm.$v.registerUser.password.$touch()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.registerInfluencer()
      }
    },
    model: {
      value: (_vm.registerUser.password),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "password", $$v)
      },
      expression: "registerUser.password"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.$v.registerUser.$invalid,
      "block": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.registerInfluencer()
      }
    }
  }, [_vm._v("Register")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left"
  }, [_vm._v("\n                  By Signing up, you confirm that you have read the\n                  "), _c('a', {
    attrs: {
      "href": "https://www.getkobe.com/influencer-terms-use-agreement/",
      "target": "_blank"
    }
  }, [_vm._v("terms and conditions")]), _vm._v(" , that you understand them and that you agree to be bound by them.\n                ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-footer', {
    attrs: {
      "dark": "",
      "height": "auto",
      "color": "#1A1A1A"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "white--text": "",
      "text-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center"
  }, [_c('u', [_vm._v("Singapore")]), _vm._v(" "), _c('br'), _vm._v("Contact:\n          "), _c('a', {
    attrs: {
      "href": "tel:+6562555662"
    }
  }, [_vm._v("6255 5662")]), _vm._v(" /\n          "), _c('a', {
    attrs: {
      "href": "mailto:contact@getkobe.com"
    }
  }, [_vm._v("CONTACT@GETKOBE.COM")]), _vm._v(" "), _c('br'), _vm._v("75 Ayer Rajah Crescent #01-09/10 Singapore 139953\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center"
  }, [_c('br'), _vm._v("Website\n          "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-terms-use"
    }
  }, [_vm._v("Terms of Use")]), _vm._v(" and\n          "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(".\n          "), _c('br'), _vm._v("All Rights Reserved © 2016-" + _vm._s(_vm.year) + " Kobe Global Technologies Pte Ltd\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center"
  }, [_c('u', [_vm._v("Malaysia / Thailand / Indonesia")]), _vm._v(" "), _c('br'), _vm._v("Contact:\n          "), _c('a', {
    attrs: {
      "href": "mailto:international@getkobe.com"
    }
  }, [_vm._v("INTERNATIONAL@GETKOBE.COM")])])])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "#A3FF12",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef1f6018"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrivateRegister.vue
// module id = 2315
// module chunks = 0